import mainMenu from "./components/main-menu";
import flickity from "./components/flickity";
import stickyNav from "./components/sticky-nav";
import reveal from "./components/reveal";
import packery from "./components/packery";
import parallax from "./components/parallax";
import exceededNav from "./components/exceeded-nav";
import infiniteScroll from "./components/infinite-scroll";
import heroSlide from "./components/hero-slide";
import subscribe from "./components/subscribe";
import registerForm from "./components/registerForm";
import abandonedOrder from "./components/abandonedOrder";
import orderStatusFilter from "./components/orderStatusFilter";
import sure from "./components/sure";
import lazyLoad from "./components/lazyLoad";
import lightbox from "./components/lightbox";

// // react apps
import favourites from "./apps/favourites/index";
import productIndex from "./apps/product-category/index";
import productPage from "./apps/product-page/index";
import cartHeader from "./apps/cart-header/index"
import checkout from "./apps/checkout/index";
import cartPage from "./apps/cart-page/index";
import addressBook from "./apps/address-book/index";
import loyaltyStatus from "./apps/loyalty-status/index";
import stockists from "./apps/stockists/index";
import favouritePage from "./apps/favourite-page/index";
import searchResults from "./apps/search-results/index";
import elementProducts from "./apps/element-products";
import events from "./components/events";
import embeds from "./components/embeds";

favourites();
productIndex();
productPage();
cartHeader();
checkout();
cartPage();
addressBook();
loyaltyStatus();
stockists();
favouritePage();
subscribe();
searchResults();
registerForm();
abandonedOrder();
elementProducts();
orderStatusFilter();
sure();
events();
embeds();


document.addEventListener("DOMContentLoaded", () => {
  mainMenu();
  flickity();
  stickyNav();
  reveal();
  packery();
  exceededNav();
  infiniteScroll();
  lazyLoad();
  lightbox();
});


window.addEventListener('load', () => {
  heroSlide();
  parallax();
  lazyLoad();
});

